<script setup>
import {ref} from 'vue'

const props = defineProps({
    oldValue: [Number, Boolean],
    newValue: [Number, Boolean]
})

// --- Reactive State ---
const class1 = ref('')
const class2 = ref('')

// --- Initialization (Formerly 'created' hook) ---
if (!props.oldValue) {
    class1.value = 'bi-square'
    class2.value = 'bi-check-square'
} else {
    class1.value = 'bi-check-square'
    class2.value = 'bi-square'
}
</script>

<template>
    <div class="d-flex align-items-center">
        <i :class="class1"/>
        <i class="mx-2 bi-chevron-right"/>
        <i :class="class2"/>
    </div>
</template>